import { render, staticRenderFns } from "./WordpressInstallPlugin.vue?vue&type=template&id=69ba9a4c&scoped=true&"
import script from "./WordpressInstallPlugin.vue?vue&type=script&lang=js&"
export * from "./WordpressInstallPlugin.vue?vue&type=script&lang=js&"
import style0 from "./WordpressInstallPlugin.vue?vue&type=style&index=0&id=69ba9a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba9a4c",
  null
  
)

export default component.exports